"use client";

import { useEffect } from "react";
import { useUserAuthDataContext } from "@/global-context/user-auth-context";
import { useChatStore } from "./chats-store";

export default function GlobalChatConnection() {
  const { userData, setUserData } = useUserAuthDataContext();
  const connect = useChatStore((state) => state.connect);
  const disconnect = useChatStore((state) => state.disconnect);

  useEffect(() => {
    // If user is logged in, connect globally
    if (userData?.idToken) {
      connect(userData.idToken, async () => {
        try {
          console.log("Refreshing session cookies...");
          const res = await fetch("/api/auth/sessionCookies");
          if (!res.ok) return null;

          const data = await res.json();

          if (data.success && data.idToken) {
            setUserData({
              ...userData,
              idToken: data.idToken,
              sessionId: data.accessToken,
              expiryTime: data.expiryTime,
            });
            return data.idToken;
          }
        } catch (error) {
          console.error("Failed to auto-refresh chat token", error);
        }
        return null;
      });
    } else {
      disconnect();
    }
  }, [userData?.idToken, connect, disconnect, setUserData]);

  return null;
}
